import PrestigeAutomation from "../../model/automation/PrestigeAutomation";
import HeaderView from "../common/HeaderView";
import PrestigeAutomationView from "../common/PrestigeAutomationView";
import Page from "../framework/Page";
import ParentView from "../framework/ParentView";
import { PageIds } from "../PageIds";
import PopupViewController from "./PopupViewController";
import PopupViewToggle from "./PopupViewToggle";

export default class MenuPanel extends ParentView {
    /**
     * @param {string} parentId
     * @param {PopupViewController} popupViewController 
     * @param {PrestigeAutomation} prestigeAutomation
     */
    constructor(parentId, popupViewController, prestigeAutomation) {
        super(parentId, PageIds.MENU_PANEL);

        this.addView(new HeaderView(this.elementId, this.elementId + '_header', 'Menu'));

        this.addView(new PopupViewToggle(this.elementId, this.elementId + '_prestige', popupViewController, PageIds.PRESTIGE_POPUP, 'Prestige'));

        const skillTreeToggle = new PopupViewToggle(this.elementId, this.elementId + '_skill', popupViewController, PageIds.SKILL_TREE_GRAPH, 'Skill Tree');
        skillTreeToggle.secondaryPopupViewId = PageIds.CLOSE_SKILL_TREE_POPUP;

        this.addView(skillTreeToggle);

        this.addView(new PopupViewToggle(this.elementId, this.elementId + '_stats', popupViewController, PageIds.STATISTICS_POPUP, 'Statistics View'));
        
        this.addView(new PopupViewToggle(this.elementId, this.elementId + '_save', popupViewController, PageIds.SAVE_POPUP, 'Save View'));

        this.addView(new PopupViewToggle(this.elementId, this.elementId + '_version', popupViewController, PageIds.VERSION_POPUP, 'Version / Release Notes'));

        this.addView(new PopupViewToggle(this.elementId, this.elementId + '_options', popupViewController, PageIds.GAME_OPTIONS_POPUP, 'Settings'));

        this.addView(new PopupViewToggle(this.elementId, this.elementId + '_performance', popupViewController, PageIds.PERFORMANCE_POPUP, 'Performance View (Dev tool)'));

        //////this.addView(new GameOptionsToggle(this.elementId, this.elementId + '_debug', 'Crew Brain Debug (Dev tool)', gameOptions));

        this.addView(new PrestigeAutomationView(this.elementId, this.elementId + '_auto_prestige', 'Auto Prestige', prestigeAutomation));
    }

    /**
     * @override
     */
    initializeView() {

        // <div id="menuPanel" class="" style="display: none;"></div>

        const parent = Page.getElement(this.parentId);
        const mainElement = Page.createElement('div', parent, this.elementId, null);

        mainElement.style.display = 'none';

        this.setViewVisible(false);
        this.setCurrentlyVisible(true);

        super.initializeView();
    }
    
}